"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hoverHighlightLineSegment = void 0;
const core_1 = require("@visualization-tools/core");
const rc_js_util_1 = require("rc-js-util");
/**
 * @public
 * Updates the state of an entity that receives a hover event.
 */
function hoverHighlightLineSegment(entity, state, segments) {
    entity.updateChangeId();
    switch (state) {
        case core_1.EHoverState.Left:
            {
                entity.graphicsSettings.pointDisplay.highlightedSegments = null;
                break;
            }
        case core_1.EHoverState.Unchanged:
        case core_1.EHoverState.Entered:
        case core_1.EHoverState.SegmentChange:
            {
                entity.graphicsSettings.pointDisplay.highlightedSegments = segments;
                break;
            }
        default:
            rc_js_util_1._Production.assertValueIsNever(state);
    }
}
exports.hoverHighlightLineSegment = hoverHighlightLineSegment;
//# sourceMappingURL=hover-highlight-line-segment.js.map